import { GenericObject } from "../types/common";
export const updateObjIf = (condition: boolean, value: GenericObject) => {
    return condition ? value : {};
};

export const filteredObjValues = (obj: GenericObject) => {
    const final = {} as any;
    for (const [key, value] of Object.entries(obj)) {
        const isEmptyArray = Array.isArray(value) && value.length === 0;
        if (value !== undefined && value !== Number.NaN && !isEmptyArray) {
            final[key] = value;
        }
    }
    return final;
};
export const filterFalseObjValues = (obj: GenericObject) => {
    const final = {} as any;
    for (const [key, value] of Object.entries(obj)) {
        if (!!value) {
            final[key] = value;
        }
    }
    return final;
};

export function getKeyByValue(keyValuePairs: GenericObject, value: any) {
    return Object.keys(keyValuePairs).find(
        (key) => keyValuePairs[key] === value,
    );
}
export function transformObjectValues(
    object: GenericObject,
    type:
        | StringConstructor
        | NumberConstructor
        | DateConstructor
        | BooleanConstructor,
) {
    const transformedObj: Record<string, unknown> = {};

    for (const key in object) {
        if (Object.prototype.hasOwnProperty.call(object, key)) {
            const value = object[key];
            if (type === Date) {
                transformedObj[key] = new type(object[key]);
            } else if (type === Boolean) {
                transformedObj[key] =
                    value === "true"
                        ? true
                        : value === "false"
                        ? false
                        : undefined;
            } else {
                transformedObj[key] = type(value);
            }
        }
    }

    return transformedObj;
}

export function getEnumKeyByEnumValue<T>(enumObj: any, enumValue: any): any {
    return Object.keys(enumObj).find((key) => enumObj[key] === enumValue);
}

export function generateObjectFromKeys<T extends readonly string[]>(
    keys: T,
): { [K in T[number]]: K } {
    return keys.reduce(
        (obj, key) => {
            obj[key as T[number]] = key as T[number];
            return obj;
        },
        {} as { [K in T[number]]: K }
    );
}

export function mergeKeyValue<
    T extends Record<string, string | number | null | undefined>,
>(
    obj: T,
    keyValSepator: string = " : ",
    options?: {
        skipNull?: boolean; // skip null | undefined
        skipEmpty?: boolean; // skip ""
        skipZero?: boolean; // skip 0
    },
): string[] {
    return Object.entries(obj)
        .filter(([, v]) => {
            if (options?.skipNull && (v === null || v === undefined))
                return false;
            if (options?.skipEmpty && v === "") return false;
            if (options?.skipZero && v === 0) return false;
            return true;
        })
        .map(([k, v]) => `${k}${keyValSepator}${v}`);
}
